import * as React from 'react';

import { FeatureFlags } from '../FeatureFlags';
import { Module } from '../Module';
import {
  GetMastheadNotificationsRequest,
  IGetMastheadNotificationsResult,
} from '../ServerApi/requests/GetMastheadNotificationsRequest';
import { ServerService } from './ServerService';
import { siteExpirationNotification } from '../../zeus/SiteExpirationNotification';
import { ToasterService, ToastType } from './ToasterService';

export class MastheadNotifications {

  private notificationsShown: boolean; // Track whether we've already shown the notifications

  public static $inject = ['$sce', '$q', 'ServerService'];

  constructor(private $sce: ng.ISCEService,
              private $q: ng.IQService,
              private ServerService: ServerService
  ) {
    this.notificationsShown = false;
  }

  public showNotificationsIfEnabled(): ng.IPromise<any> {
    if (this.notificationsShown) {
      return this.$q.when(null);
    }
    return this.fetchNotificationsUrl().then((url: string) => {

      if (url) {
        if (FeatureFlags.siteExpirationNotificationEnabled) {
          if (siteExpirationNotification) {
            siteExpirationNotification.showNotificationsIfEnabled();
          }
          return;
        }

        url = this.$sce.trustAsResourceUrl(url);
        class ContentComponent extends React.Component<any, any> {
          render() {
            return React.createElement('iframe', {
              src: url,
              style: {
                verticalAlign: 'top',
                width: '100%',
                height: '36px'
              },
              frameBorder: '0',
              scrolling: 'no'
            });
          }
        }

        ToasterService.instance.pop({
          type: ToastType.External,
          content: React.createElement(ContentComponent, {}),
          timeoutDelay: ToasterService.NoTimeout
        });

      }
    }).finally(() => this.notificationsShown = true); // Suppress in case of future remounting

  }

  private fetchNotificationsUrl(): ng.IPromise<string> {
    return this.ServerService.sendRequest(new GetMastheadNotificationsRequest())
      .then((result: IGetMastheadNotificationsResult) => result.contentUrl);
  }

}

Module.instance().service('MastheadNotifications', MastheadNotifications);
